export function createUsername(fullName?: string | null): string {
  if (!fullName) return ''
  const nameParts = fullName.trim().split(' ')
  const firstName = nameParts[0]
  const lastNameInitial = nameParts.length > 1 ? nameParts[1][0] : ''
  return lastNameInitial ? `${firstName} ${lastNameInitial}` : firstName
}

export function getUsernameInitials(fullName?: string | null) {
  if (!fullName) return ''
  const nameParts = fullName
    .trim()
    .split(' ')
    .map((part) => part.trim())
    .filter(Boolean)

  if (!nameParts.length) return ''

  const firstName = nameParts[0]
  const secondInitial =
    nameParts.length > 1 ? nameParts[1][0] : firstName[1] || ''
  return `${firstName[0]}${secondInitial}`
}
